"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BLACKLISTED_USER_MESSAGE = void 0;
exports.BLACKLISTED_USER_MESSAGE = 'Your collection has been denied. Reach out to support to continue forward.';
